<template>
  <el-row :gutter="20">
    <el-col v-for="(field, index) in fields" :key="index" :span="12">
      <span class="label">{{ field.label }}</span
      ><br />
      <span class="value">{{ row[field.key] }}</span>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "viewRecord",
  props: {
    fields: {
      type: Array,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped>
/* Label Style */
.label {
  color: #677788;
  font-size: 12px; /* Adjust font size for label */
  line-height: medium; /* Line height for better spacing */
}

/* Value Style */
.value {
  color:#606266;
  font-size: 12px; /* Adjust font size for value */
  line-height: medium; /* Line height for better spacing */
}
</style>
